import Icon from '../components/Icon.vue'

Icon.register({
  stopwatch: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M432 304c0 114.9-93.1 208-208 208s-208-93.1-208-208c0-104 76.3-190.2 176-205.5v-34.5h-28c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-0.6 0.6c21.2 32.4 33.5 71.3 33.5 113.1zM256 340v-151.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v151.5c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/stopwatch.js
// module id = 1956
// module chunks = 0